import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import {
  HiOutlineClipboardList,
  HiOutlineLocationMarker,
  HiOutlineArrowLeft,
  HiOutlineTruck,
} from "react-icons/hi";
import { scrollTop } from "../../utils/window";
import { ShimmerThumbnail } from "react-shimmer-effects";
import {
  CAR_DETAIL_UPDATE,
  ADD_CAR_FEATURES,
  GET,
  POST,
} from "../../constant";
import SearchCity from "../../components/SearchCity";
import InputTypes from "../../components/InputTypes";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import Labels from "../../services/apiLabels";
import {
  buildDivindexFromVehicleDetails,
  getResumeWizardIndex,
  getNextWizardIndex,
  isChoiceSelected,
} from "../../utils/vehicleDetails";

function VehicleStepRail({ car_data, index, isAddressStep }) {
  const questionCount = car_data?.length ?? 0;

  return (
    <nav className="pi-vehicle-wizard__rail" aria-label="Vehicle details progress">
      {car_data.map((item, i) => {
        const isActive = !isAddressStep && index === i;
        const isComplete = isAddressStep || index > i;

        return (
          <div
            key={item.question_id ?? i}
            className={`pi-vehicle-wizard__rail-item ${
              isActive ? "is-active" : ""
            } ${isComplete ? "is-complete" : ""}`}
            aria-current={isActive ? "step" : undefined}
          >
            <span className="pi-vehicle-wizard__rail-icon" aria-hidden>
              <HiOutlineClipboardList size={16} />
            </span>
            <span className="pi-vehicle-wizard__rail-label">
              Question {i + 1}
            </span>
          </div>
        );
      })}
      {questionCount > 0 ? (
        <div
          className={`pi-vehicle-wizard__rail-item ${
            isAddressStep ? "is-active" : ""
          }`}
          aria-current={isAddressStep ? "step" : undefined}
        >
          <span className="pi-vehicle-wizard__rail-icon" aria-hidden>
            <HiOutlineLocationMarker size={16} />
          </span>
          <span className="pi-vehicle-wizard__rail-label">Location</span>
        </div>
      ) : null}
    </nav>
  );
}

export function CarUpdateWizard({
  car_data,
  getcardetail,
  evaluation_id_,
  loading,
  vehicle_details_change,
  carfeatureadd,
  evaluation,
  divindex,
  inline = false,
  onClose,
  hydrateDivindex,
  featureSaveSettledAt,
}) {
  const { feedback } = useContext(FeedbackContext);
  const carupdate_page = feedback.carupdate_page;
  const car_steps_page = feedback.car_steps_page || {};
  const history = useHistory();

  const [no, setno] = useState(1);
  const [index, setIndex] = useState(0);
  const [awaitingAdvance, setAwaitingAdvance] = useState(false);
  const advanceAfterSaveRef = useRef(0);
  const resumeAppliedRef = useRef(false);

  useEffect(() => {
    getcardetail(evaluation?.id ? evaluation : {}, evaluation_id_);
  }, []);

  useEffect(() => {
    if (loading || !car_data?.length || !evaluation?.vehcile_details?.length) {
      return;
    }

    const nextDivindex = buildDivindexFromVehicleDetails(
      evaluation.vehcile_details,
      car_data
    );

    if (Object.keys(nextDivindex).length > 0) {
      hydrateDivindex(nextDivindex);
    }
  }, [loading, car_data, evaluation?.vehcile_details]);

  useEffect(() => {
    if (loading || !car_data?.length || resumeAppliedRef.current) {
      return;
    }

    const resumeIndex = getResumeWizardIndex(
      car_data,
      evaluation?.vehcile_details,
      evaluation?.vehicle_address
    );

    setIndex(resumeIndex);
    resumeAppliedRef.current = true;
  }, [loading, car_data, evaluation?.vehcile_details, evaluation?.vehicle_address]);

  useEffect(() => {
    if (!inline) {
      scrollTop();
      return;
    }
    const panel = document.querySelector(".pi-vehicle-wizard__panel");
    panel?.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, [index, inline]);

  const questionCount = car_data?.length ?? 0;

  useEffect(() => {
    if (!awaitingAdvance || !featureSaveSettledAt) {
      return;
    }

    if (featureSaveSettledAt <= advanceAfterSaveRef.current) {
      return;
    }

    advanceAfterSaveRef.current = featureSaveSettledAt;
    setAwaitingAdvance(false);

    if (index < questionCount) {
      setIndex(getNextWizardIndex(index, car_data));
    }
  }, [awaitingAdvance, featureSaveSettledAt, index, questionCount, car_data]);

  const totalSteps = questionCount + 1;
  const isAddressStep = !loading && questionCount > 0 && index >= questionCount;
  const currentStepNum = loading
    ? 1
    : index < questionCount
      ? index + 1
      : totalSteps;
  const progress = totalSteps
    ? Math.round((currentStepNum / totalSteps) * 100)
    : 0;

  const handleClose = () => {
    if (onClose) {
      onClose();
      return;
    }
    history.push("/carsteps");
  };

  const hasCurrentSelection = () => {
    const selected = divindex?.[index];
    return Array.isArray(selected) && selected.length > 0;
  };

  const persistCurrentAnswer = () => {
    if (!car_data[index] || !hasCurrentSelection()) return;

    carfeatureadd({
      evaluation: evaluation_id_,
      question: car_data[index]["question_id"],
      feature: divindex[index],
    });

    const f = [];
    for (let i = 0; i < car_data[index]["choices"].length; i++) {
      const choice = car_data[index]["choices"][i];
      if (isChoiceSelected(divindex, index, choice.choice_id)) {
        f.push({
          id: choice.choice_id,
          choice: choice.name,
        });
      }
    }

    vehicle_details_change({
      id: 43,
      question_: car_data[index]["question"],
      question: car_data[index]["question_id"],
      feature: f,
    });
  };

  const nextSlide = (move = true) => {
    setno(no + 1);

    if (hasCurrentSelection()) {
      persistCurrentAnswer();
      if (move) {
        setAwaitingAdvance(true);
      }
      return;
    }

    if (move && index < questionCount) {
      setIndex(getNextWizardIndex(index, car_data));
    }
  };

  const prevSlide = () => {
    if (index === 0) {
      setno(0);
      if (inline && onClose) {
        onClose();
      } else {
        history.goBack();
      }
      return;
    }
    setno(no - 1);
    setIndex((i) => i - 1);
  };

  const saveAndExit = () => {
    if (!isAddressStep) {
      persistCurrentAnswer();
    }
    handleClose();
  };

  const stageTitle = isAddressStep
    ? carupdate_page.Provide_Your_Address
    : car_data[index]?.question;

  const stageLead = isAddressStep
    ? carupdate_page.Enter_postcode_first_line ||
      carupdate_page["Enter_postcode_first_line "] ||
      carupdate_page.Enter_Your_Address
    : hasCurrentSelection()
      ? car_data[index]?.select == "1"
        ? "Select one option that best describes your vehicle."
        : "Select all options that apply to your vehicle."
      : "You can select an option below, or press Next to skip this question.";

  const renderActions = () => {
    if (loading) return null;

    if (isAddressStep) {
      return (
        <div className="pi-vehicle-wizard__actions">
          <button
            type="button"
            onClick={prevSlide}
            className="pi-car-update__btn pi-car-update__btn--outline"
          >
            {carupdate_page.Previous_button_text}
          </button>
          <button
            type="button"
            onClick={saveAndExit}
            className="pi-car-update__btn pi-car-update__btn--ghost"
          >
            {carupdate_page.Save_and_exit}
          </button>
        </div>
      );
    }

    if (index < questionCount) {
      return (
        <div className="pi-vehicle-wizard__actions">
          <button
            type="button"
            onClick={prevSlide}
            className="pi-car-update__btn pi-car-update__btn--outline"
          >
            {carupdate_page.Previous_button_text}
          </button>
          {inline ? (
            <button
              type="button"
              onClick={saveAndExit}
              className="pi-car-update__btn pi-car-update__btn--ghost"
            >
              {carupdate_page.Save_and_exit}
            </button>
          ) : (
            <Link
              onClick={() => {
                nextSlide(false);
              }}
              to="/carsteps"
              className="pi-car-update__btn pi-car-update__btn--ghost"
            >
              {carupdate_page.Save_and_exit}
            </Link>
          )}
          <button
            type="button"
            onClick={() => nextSlide(true)}
            className="pi-car-update__btn pi-car-update__btn--primary"
            disabled={awaitingAdvance}
          >
            {awaitingAdvance ? "Saving…" : carupdate_page.Next_button_text}
          </button>
        </div>
      );
    }

    return null;
  };

  const renderStage = () => {
    if (loading) {
      return (
        <div className="pi-car-update__skeleton">
          <ShimmerThumbnail height={28} width={280} rounded />
          <ShimmerThumbnail height={18} width={360} rounded />
          <div className="pi-car-update__skeleton-choices">
            <ShimmerThumbnail height={52} rounded />
            <ShimmerThumbnail height={52} rounded />
            <ShimmerThumbnail height={52} rounded />
            <ShimmerThumbnail height={52} rounded />
          </div>
        </div>
      );
    }

    if (index < questionCount) {
      return (
        <InputTypes
          embedded
          data={car_data[index]}
          index_of={index}
          stepMeta={currentStepNum}
        />
      );
    }

    return <SearchCity embedded onComplete={handleClose} />;
  };

  const wizardShell = (
    <div className={`pi-vehicle-wizard ${inline ? "pi-vehicle-wizard--inline" : ""}`}>
      {inline ? (
        <div className="pi-vehicle-wizard__toolbar">
          <button
            type="button"
            className="pi-vehicle-wizard__back"
            onClick={handleClose}
          >
            <HiOutlineArrowLeft size={18} aria-hidden />
            <span>Back to steps</span>
          </button>
          <span className="pi-vehicle-wizard__toolbar-title">
            {car_steps_page.Vehicle_Details?.trim() || "Vehicle details"}
          </span>
        </div>
      ) : null}

      {!loading && questionCount > 0 ? (
        <VehicleStepRail car_data={car_data} index={index} isAddressStep={isAddressStep} />
      ) : null}

      <div className="pi-vehicle-wizard__layout">
        <aside className="pi-vehicle-wizard__aside">
          <div className="pi-vehicle-wizard__summary">
            <span className="pi-vehicle-wizard__summary-icon" aria-hidden>
              <HiOutlineTruck size={22} />
            </span>
            <p className="pi-vehicle-wizard__summary-eyebrow">
              Step {currentStepNum} of {totalSteps || "—"}
            </p>
            <h3 className="pi-vehicle-wizard__summary-title">
              {loading
                ? "Loading questions…"
                : isAddressStep
                  ? "Vehicle location"
                  : "Vehicle profile"}
            </h3>
            <p className="pi-vehicle-wizard__summary-lead">
              {car_steps_page.Vehicle_Information ||
                "Help us build an accurate picture of your vehicle."}
            </p>
            <div
              className="pi-vehicle-wizard__summary-progress"
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin={0}
              aria-valuemax={100}
            >
              <div
                className="pi-vehicle-wizard__summary-progress-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
            <span className="pi-vehicle-wizard__summary-percent">{progress}% complete</span>
          </div>
        </aside>

        <div className="pi-vehicle-wizard__main">
          <div className="pi-vehicle-wizard__panel">
            {!loading ? (
              <header className="pi-vehicle-wizard__panel-head">
                <h2 className="pi-vehicle-wizard__panel-title">{stageTitle}</h2>
                <p className="pi-vehicle-wizard__panel-lead">{stageLead}</p>
              </header>
            ) : null}
            <div className="pi-vehicle-wizard__panel-body">{renderStage()}</div>
          </div>
          {renderActions()}
        </div>
      </div>
    </div>
  );

  if (inline) {
    return (
      <div className="pi-car-steps__edit-panel pi-car-steps__edit-panel--vehicle">
        {wizardShell}
      </div>
    );
  }

  return <div className="pi-car-update__inner">{wizardShell}</div>;
}

const mapStateToProps = (state) => ({
  car_data: state.cardeailupdate.data,
  loading: state.cardeailupdate.loading,
  featureSaveSettledAt: state.cardeailupdate.featureSaveSettledAt,
  divindex: state.cardeailupdate.divindex,
  evaluation_id_: state.sellMyCar.evaluation_create.id,
  evaluation: state.sellMyCar.evaluation_create,
});

const mapDispatchToProps = (dispatch) => ({
  hydrateDivindex: (divindex) =>
    dispatch({
      type: "HYDRATE_VEHICLE_DIVINDEX",
      payload: { divindex },
    }),
  carfeatureadd: (data) =>
    dispatch({
      type: ADD_CAR_FEATURES,
      payload: {
        type: ADD_CAR_FEATURES,
        method: POST,
        label: Labels.add_feaderes,
        hideOverlayLoader: true,
        data,
      },
    }),
  vehicle_details_change: (data_v) =>
    dispatch({
      type: "CAR_UPDATE_DETAILS",
      payload: {
        type: "CAR_UPDATE_DETAILS",
        data: data_v,
      },
    }),
  getcardetail: (data = [], id) =>
    dispatch({
      type: CAR_DETAIL_UPDATE,
      payload: {
        type: CAR_DETAIL_UPDATE,
        label: `${Labels.carDetail_Update}?id=${id}`,
        method: GET,
        hideOverlayLoader: true,
        data_vehicle: data,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CarUpdateWizard);
